import type { ThemeEarningsColumnLayout } from '../theme-earnings-table/ThemeEarningsTable';
import styles from './EarningsReportingSummary.module.scss';

export const REPORTING_THIS_WEEK_COLUMN_LAYOUT: Record<
  string,
  ThemeEarningsColumnLayout
> = {
  rank: {
    headerClassName: styles.rankHeader,
    cellClassName: styles.rankCell,
    headerAlignment: 'start',
    cellAlignment: 'center',
  },
  company: {
    headerClassName: styles.companyHeader,
    cellClassName: styles.companyCellWrapper,
    headerAlignment: 'start',
    cellAlignment: 'left',
  },
  'scheduled-date': {
    headerClassName: styles.dateHeader,
    cellClassName: styles.dateCell,
    headerAlignment: 'start',
    cellAlignment: 'left',
  },
  'expected-eps': {
    headerAlignment: 'end',
    cellAlignment: 'end',
  },
  'expected-revenue': {
    headerAlignment: 'end',
    cellAlignment: 'end',
  },
  'themes-to-watch': {
    headerClassName: styles.flexHeader,
    cellClassName: styles.topicsCellWeek,
    headerAlignment: 'start',
    cellAlignment: 'left',
  },
};
